var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"tag has-text-bold is-small",class:_vm.color,staticStyle:{"font-weight":"900"}},[_c('b',[_vm._v(" "+_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }